import React, {useMemo} from 'react';
import BaseTextProps from './base-text.props';
import styles from './base-text.styles';
import {TypographyFontStyles, TypographySizes} from './constants';

const BaseText = ({
  size = TypographySizes.M,
  variant,
  fontStyle = TypographyFontStyles.Regular,
  stringProps,
  children,
  textStyle,
  style,
  italic = false,
  ...baseTextProps
}: BaseTextProps) => {
  //   <p style={{fontSize: }}></p>
  // TODO: IMPLEMENT I18N FOR TRANSLATION IN STRINGPROPS
  const stringPropsText = stringProps?.plainText;

  const italicStyles = useMemo(() => (italic ? styles.Italic : {}), [italic]);

  const manipulatedBaseTextProps = useMemo(
    () => ({
      ...baseTextProps,
      style: {
        ...styles.resetDefaults,
        ...styles[fontStyle],
        ...italicStyles,
        ...style,
        ...textStyle,
        ...styles.defaultFont,
      },
    }),
    [baseTextProps, fontStyle, italicStyles, style, textStyle],
  );

  const CurrentComponent: string = variant;

  return (
    <CurrentComponent {...manipulatedBaseTextProps}>
      {stringPropsText}
    </CurrentComponent>
  );
};

export default BaseText;
